import { apiServerRoutes } from "constants/apiRoutes";
import { handleSnackBar } from "slices/global";
import { getAPICallServer } from "utils/axios.util";

const formatNumericVal = (val: any) => (!val || val == 0 ? undefined : val);

export const populateEditValues = async (
  id: any,
  setValue: any,
  dispatch: any,
  setStepStatus: any
) => {
  try {
    setStepStatus((prev: any) => {
      const keys = Object.keys(prev);
      keys?.forEach((k) => (prev[k] = { loading: true, submitted: false }));
      return prev;
    });
    let prevData = await getAPICallServer(
      `${apiServerRoutes.LISTING_DETAILS.replace(":id", id)}`
    );
    if (prevData?.status != 200) {
      return dispatch(
        handleSnackBar({
          open: true,
          message: "Error Fetching the existing data.",
          severity: "error",
        })
      );
    }
    prevData = prevData?.data?.data;
    setValue("equipmentType", prevData?.listing_type);
    setValue("id", prevData?.id);
    setValue("price", prevData?.price);
    setValue("price_unit", prevData?.price_unit);
    setValue("listing_name", prevData?.listing_name);
    setValue("listing_description", prevData?.listing_description);

    setValue("attachment_id", prevData?.attachment_id);
    setValue(
      "has_loader_bucker",
      prevData?.listing_features[0]?.has_loader_bucker
    );
    setValue("has_ac", prevData?.listing_features[0]?.has_ac);
    setValue("has_3point_lift", prevData?.listing_features[0]?.has_3point_lift);
    setValue("has_heater", prevData?.listing_features[0]?.has_heater);
    setValue("has_pto", prevData?.listing_features[0]?.has_pto);
    setValue("has_cabin", prevData?.listing_features[0]?.has_cabin);
    setValue(
      "has_power_steering",
      prevData?.listing_features[0]?.has_power_steering
    );
    setValue(
        "has_4wd",
        prevData?.listing_features[0]?.has_4wd
      );
    

    setValue("horse_power", prevData?.listing_features[0]?.horse_power);
    setValue("year", prevData?.listing_features[0]?.year);
    setValue("capacity", prevData?.listing_features[0]?.capacity);
    setValue("capacity_unit", prevData?.listing_features[0]?.capacity_unit);
    setValue("attachment_type", prevData?.listing_features[0]?.attachment_type);

    setValue("usage_type", prevData?.listing_configs[0]?.usage_type);
    setValue(
      "custom_hours",
      formatNumericVal(prevData?.listing_configs[0]?.custom_hours)
    );
    setValue(
      "custom_excess_hours_fee",
      formatNumericVal(prevData?.listing_configs[0]?.custom_excess_hours_fee)
    );
    setValue(
      "custom_min_rental_duration",
      formatNumericVal(prevData?.listing_configs[0]?.custom_min_rental_duration)
    );
    setValue("emv", prevData?.listing_configs[0]?.emv);
    setValue("manufacturer_id", prevData?.manufacturer_id);
    let timeOutId: any = setTimeout(() => {
      setValue("manufacturer_model_id", prevData?.manufacturer_model_id);
      clearTimeout(timeOutId);
    }, 0);
    setValue("images", prevData?.images);
    setValue("deletedImages", []);
    setStepStatus((prev: any) => {
      const keys = Object.keys(prev);
      keys?.forEach((k) => (prev[k] = { loading: false, submitted: true }));
      return prev;
    });
  } catch (e) {
    setStepStatus((prev: any) => {
      const keys = Object.keys(prev);
      keys?.forEach((k) => (prev[k] = { loading: false, submitted: false }));
      return prev;
    });
    return dispatch(
      handleSnackBar({
        open: true,
        message: "Error Fetching the existing data.",
        severity: "error",
      })
    );
  }
};
